import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { applyAuthParams, hasToken } from "./utils/authToken";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  applyAuthParams(location.search);
  return hasToken() ? children : <Navigate to="/auditor/auth/login" replace />; //replace =>  Replaces the current history entry (no "back" to the previous page) that means If the user is not authenticated, they get redirected to /login without being able to go back to the protected page by pressing the back button..
};

export default PrivateRoute;
